module.exports = __webpack_public_path__ + "static/media/planet1.0c924ef5.png";